/* eslint-env browser */

document.documentElement.classList.add('js')
